export const eventHandlers = {
  CHECKOUT_SHIPPING_METHOD_PAGE_VIEW: 'CHECKOUT_SHIPPING_METHOD_PAGE_HIT',
  SELECT_DELIVERY_METHOD_CHECKOUT_SHIPPING_METHOD: 'SELECT_DELIVERY_METHOD_CHECKOUT_SHIPPING_METHOD_CLICK',
};
